<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import { Progress } from 'vant';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useCommonQuesListEffect } from '@/effects/quesListEffect'

const showMatch = ref(false);

//  1.2s后显示匹配成功
setTimeout(() => {
  showMatch.value = true;
}, 1800);

const percentage = ref(0)

// 随机1s到2.5s
const randomTime = Math.floor(Math.random() * 1500) + 1000
// percentage在随机时间内，逐步增加到100
setTimeout(() => {
  const timer = setInterval(() => {
    percentage.value += 1
    if (percentage.value >= 100) {
      clearInterval(timer)
    }
  }, 10)
}, randomTime)

const router = useRouter()
const route = useRoute()
const store = useStore()
watch(percentage, () => {
  if (percentage.value >= 100) {

   setTimeout(() => {
     // 记录答题开始时间
     store.commit('setStartTime', {
      time: new Date(),
    })
    router.push({
      path: '/competition/question',
      query: {
        ...route.query,
        type: 'pk',
      }
    })
   }, 500)
  }
})

// 获取随机用户信息,从public下的json下的user.json中获取
const getUserInfo = () => {
  const users = require('/public/json/user.json')
  const randomIndex = Math.floor(Math.random() * users.length)
  const user =  users[randomIndex]

  store.commit('setRobot', user)
}

const robot = computed(() => {
  return store.getters?.getRobot
})

const user = computed(() => {
  return store.getters?.getUser
})

// 提前获取题目数据
const { getQuesData, loading } = useCommonQuesListEffect()
onMounted(() => {
  getQuesData()
  getUserInfo()
})

</script>
<template>
  <div class="pk-loading-wrap">
    <div v-if="!showMatch">
      <div class="loading-content rotate">
        <img class="avatar" :src="user?.avatar" alt="" />
      </div>
      <p class="loading-text">正在匹配中...</p>
    </div>
    <div v-else class="pk-match-wrap">
      <div class="match-content">
        <div class="match-left animate__animated animate__slideInLeft">
          <img class="match-avatar" :src="user.avatar"
            alt="">
          <p class="match-name">{{ user?.nickname }}</p>
        </div>
        <div class="match-right animate__animated animate__slideInRight">
          <img class="match-avatar" :src="robot?.avatar"
            alt="">
          <p class="match-name">{{ robot?.nickname }}</p>
        </div>
        <!-- pk log -->
        <img class="match-logo animate__animated animate__jackInTheBox" src="@/assets/img/pk/vs.png" alt="">
      </div>
      <Progress class="match-progress" :percentage="percentage" stroke-width="18" />
      <p class="progress-tips">正在准备答题战场...</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pk-loading-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;

  .loading-content {
    position: relative;
    margin-top: 290px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 606px;
    height: 604px;


    &::before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: no-repeat center / 100% url('../../../assets/img/pk/loading.png');
      animation: rotate 2.6s linear infinite;
    }

    img.avatar {
      width: 144px;
      height: 144px;
      border-radius: 50%;
      object-fit: cover;
      z-index: 1;
    }
  }

  .loading-text {
    margin-top: 60px;
    font-size: 44px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }

  .pk-match-wrap {
    margin-top: 232px;

    .match-content {
      margin: 0 auto;
      position: relative;
      width: 700px;
      height: 576px;

      .match-left,
      .match-right {
        box-sizing: border-box;
        position: absolute;
        width: 468px;
        height: 374px;

        .match-name {
          margin-top: 16px;
          width: 200px;
          font-size: 32px;
          color: #FFFFFF;
          font-weight: bold;
          text-align: center;
        }

        .match-avatar {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          object-fit: cover;
        }

      }

      .match-left {
        top: 0;
        left: 0;
        background: no-repeat top / 100% url('../../../assets/img/pk/match-left-bg.png');

        .match-avatar {
          margin-top: 64px;
          margin-left: 116px;
        }

        .match-name {
          margin-left: 80px;
        }
      }

      .match-right {
        right: 0;
        bottom: 0;
        background: no-repeat top / 100% url('../../../assets/img/pk/match-right-bg.png');

        .match-avatar {
          margin-top: 102px;
          margin-left: 230px;
        }

        .match-name {
          margin-left: 198px;
        }
      }

      .match-logo {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 190px;
        height: 200px;
      }
    }

    .match-progress {
      margin-top: 128px;
      border-radius: 18px;
    }

    .progress-tips {
      margin-top: 28px;
      text-align: center;
      font-size: 28px;
      color: #333333;
    }
  }
}

// 旋转的动画
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg)
  }
}</style>
